import { DeeplinkKeys, DynamicParams } from '../../enums';
import { CTAData } from '@dh-io-globalelem/vehicle-data-store-connection';

export const assignDynamicValues = (ctaData: CTAData, configurationId?: string): CTAData => {
  const updatedCTAData = { ...ctaData };

  Object.keys(updatedCTAData).forEach((key) => {
    const ctaItem = updatedCTAData[key as keyof CTAData];
    if (ctaItem && ctaItem.type === DeeplinkKeys.Configurator && configurationId) {
      const url = appendURLParam(ctaItem.baseUrl, configurationId);
      updatedCTAData[key as keyof CTAData] = { ...ctaItem, url: url };
    }
  });

  return updatedCTAData;
};

const appendURLParam = (baseUrl: string, configurationId: string): string => {
  const url = new URL(baseUrl);

  if (url.hash) {
    appendURLParamToHash(url, configurationId);
  } else {
    url.searchParams.set(DynamicParams.VehicleId, configurationId);
  }

  return url.toString();
};

const appendURLParamToHash = (url: URL, configurationId: string): void => {
  const existingParams = url.hash.indexOf('?') > -1 ? url.hash.substring(url.hash.lastIndexOf('?') + 1) : '';
  const queryParams = new URLSearchParams(existingParams);

  queryParams.set(DynamicParams.VehicleId, configurationId);
  url.hash = `${url.hash.replace(`?${existingParams}`, '')}?${queryParams.toString()}`;
};
